import React from "react";

import { Navigate } from "react-router-dom";

import PATH from "../../constants/routes";
import BasePage from "../../pages/BasePage/BasePage";

export default function PrivateRoutes() {
  let token = true;
  if (!token) {
    return <>no token</>;
  }
  return <BasePage />;
}
